import $ from 'jquery';
import Api from '../util/Api';

import CatalogDetailFeaturesItem from '../template/CatalogDetailFeaturesItem';
import CatalogDetailTagsItem from '../template/CatalogDetailTagsItem';
import CatalogDetailGalleryItem from '../template/CatalogDetailGalleryItem';
import CatalogDetailDocument from '../template/CatalogDetailDocument';

const CatalogDetailService = {
    productCode: '',
    offersByCode: {},
    offersByUrl: {},
    init() {
        this.productCode = $('.catalog-detail').attr('data-code');
    },
    getItem(productCode) {
        return Api.get('/api/catalog/product/', { code: productCode })
            .then((response) => {
                return response;
            });
    },
    loadOffers() {
        const code = [];
        $('.catalog-detail-offers__item').each(function () {
            code.push($(this).attr('data-code'));
        });
        if (code.length > 1) {
            Api.get('/api/catalog/product/', { code })
                .then((response) => {
                    response.items.forEach((product) => {
                        this.offersByCode[product.code] = product;
                        this.offersByUrl[product.url] = product;
                    });
                });
        }
    },
    renderOffer(offer) {
        const oldWindowTop = $(window).scrollTop();
        const oldOffsetTop = $('.catalog-detail-offers').offset().top;

        this.productCode = offer.code;

        $('.catalog-detail-purchase__button').attr('data-product-id', offer.id);

        this.renderPoints(offer.points);
        this.renderPrice(offer.price);
        this.renderAvailable(offer.available);
        this.renderTexts(offer);
        // labels
        this.renderTemplate(CatalogDetailFeaturesItem, '.catalog-detail-features', offer.properties.labels);
        // hashtags
        this.renderTemplate(CatalogDetailTagsItem, '.catalog-detail-tags', offer.properties.hashtags);
        // gallery
        if (offer.properties.images.length > 1) {
            $('.catalog-detail-thumbs').removeClass('hidden');
        } else {
            $('.catalog-detail-thumbs').addClass('hidden');
        }
        this.renderTemplate(CatalogDetailGalleryItem, '.catalog-detail-thumbs', offer.properties.images);
        $('.catalog-detail-gallery__item--preview').first().click();
        // documents
        this.renderTemplate(CatalogDetailDocument, '.catalog-detail-documents', offer.properties.files);

        // сохраняем страницу относительно положения мыши на ней
        const newOffsetTop = $('.catalog-detail-offers').offset().top;
        $(window).scrollTop(oldWindowTop + newOffsetTop - oldOffsetTop);
    },
    renderTemplate(template, classname, array) {
        $(classname).html(array.map(template).join(''));
    },
    renderTexts(offer) {
        $('.catalog-detail__article span').text(offer.properties.article.trim());
        $('.catalog-detail__title').text(offer.name.trim());
        $('.catalog-detail__subtitle').text(offer.properties.subtitle.trim());
        $('.catalog-detail__preview-text').text(offer.preview_text.trim());
        $('.content-tabs-block--detail-text').text(offer.detail_text.trim());
        $('.content-tabs-block--composition').text(offer.properties.composition.trim());
        $('.content-tabs-block--usage').text(offer.properties.usage.trim());
    },
    renderPoints(points = false) {
        if (points) {
            $('.catalog-detail-purchase__points').removeClass('hidden');
            $('.catalog-detail-subscribe__points').removeClass('hidden');

            $('.catalog-detail-purchase__points span').text(points);
            $('.catalog-detail-subscribe__points span').text(points);
        } else {
            $('.catalog-detail-purchase__points').addClass('hidden');
            $('.catalog-detail-subscribe__points').addClass('hidden');
        }
    },
    renderPrice(price = false) {
        $('.catalog-detail-purchase__price').text(price);
    },
    renderAvailable(available = false) {
        $('.catalog-detail-subscribe__footer').removeClass('hidden');
        $('.catalog-detail-subscribe__success').addClass('hidden');

        if (available) {
            $('.catalog-detail-purchase').removeClass('hidden');
            $('.catalog-detail-subscribe').addClass('hidden');
        } else {
            $('.catalog-detail-purchase').addClass('hidden');
            $('.catalog-detail-subscribe').removeClass('hidden');
        }
    }
};

export default CatalogDetailService;
